import type { Metadata } from 'next';
import { notFound } from 'next/navigation';
import { isLocale } from '@ai-radar/shared';
import { getDictionary } from '@/lib/dictionary';
import { AuthForm } from '@/components/auth/AuthForm';

type Params = Promise<{ lang: string }>;

export async function generateMetadata({ params }: { params: Params }): Promise<Metadata> {
  const { lang } = await params;
  if (!isLocale(lang)) return {};

  return {
    title: lang === 'ar' ? 'إنشاء حساب' : 'Create account',
    robots: { index: false, follow: true },
  };
}

export default async function RegisterPage({ params }: { params: Params }) {
  const { lang } = await params;
  if (!isLocale(lang)) notFound();

  return (
    <main id="main" className="page auth-page">
      <AuthForm mode="register" locale={lang} dict={getDictionary(lang)} />
    </main>
  );
}
